import React from 'react';
import { Link } from 'react-router-dom';
import "./../styles/SpecialReservationSection.css";

function SpecialReservationSection() {
    return (
        <section className="special-reservation-section">
            <div className="special-reservation-container">
                <div className="reservation-card">
                    <h2 className="reservation-title">Spend Your Special Days with Us</h2>
                    <p className="reservation-text">
                        Whether it's a birthday, anniversary, or any special occasion, Sol Cafe & Lounge is the perfect place to celebrate.
                    </p>
                    <Link to="/reserve" className="reservation-button">
                        Reserve Now
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default SpecialReservationSection;
